$( document ).ready(function() {

  // MARQUEE
  Marquee3k.init({
    selector: 'marquee3k'
  });
  

  // FADE IN/OUT
  window.addEventListener("beforeunload", function () {
    $("body").addClass("fade-out");
  });
  window.addEventListener("pageshow", function() {
    setTimeout(function(){
    	$("body").removeClass("fade-out");
    }, 250);
  }, false);
  setTimeout(function(){
    $("body").removeClass("fade-out");
  }, 500);

  // LAZY LOADING
  var L = [].slice.call(document.querySelectorAll('.lazy'));
  if('IntersectionObserver' in window){
    let o = new IntersectionObserver(function(E, observer){
      E.forEach(function(e){
        if(e.isIntersecting){
          let l = e.target;
          if(l.tagName == 'IMG'){
            setTimeout(function(){
              l.src = l.dataset.src;
            }, 500);
          }
          if(l.tagName == 'VIDEO'){
            var P = l.play();
            if(P !== undefined){
              P.catch(error => {
                l.controls = true;
                l.classList.add('no-autoplay');
              });
            }
          }
          l.classList.remove('lazy');
          o.unobserve(l);
        }
      });
    });
    L.forEach(function(l){
      o.observe(l);
    });
  }
  
  // POP UP PASSWORD
  $('.close-newsletter-pop-up-password').on('click', function() {
      $('#mailchimp-container-password').addClass('hidden');
  });

  // HEADER BANNER
  $('.header-banner span').on('click', function(event) {
      event.preventDefault();
      $('body').addClass('no-banner');
  });

  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    
});








